import { colors } from '@/constants/colors';
import IconsLib from '@/utils/IconsLib';
import React from 'react';
import styled from 'styled-components';

interface Props {
   label?: string;
   name: string;
   value: string;
   placeholder: string;
   disabled?: boolean;
   error?: string;
   onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const InputTextarea = ({
   label,
   name,
   value,
   placeholder,
   disabled,
   error,
   onChange,
}: Props) => {
   return (
      <Wrapper>
         {label && <Label>{label}</Label>}
         <FormInput
            $disabled={disabled === true ? 'true' : 'false'}
            $error={(error ?? '').length > 0 ? 'true' : 'false'}
            name={name}
            value={value}
            rows={3}
            cols={50}
            placeholder={placeholder}
            onChange={onChange}
            disabled={disabled}
         />
         {error && (
            <ErrorWrapper>
               <IconsLib
                  icon="error-warning-fill"
                  size="15px"
                  color={colors.DANGER}
               />
               <LabelRequired>{error}</LabelRequired>
            </ErrorWrapper>
         )}
      </Wrapper>
   );
};

const Wrapper = styled.div`
   display: flex;
   flex-direction: column;
   gap: 0.5rem;
`;

const Label = styled.label`
   font-size: 13px;
   /* font-weight: 600; */
   color: ${colors.GRAY1};
`;

const FormInput = styled.textarea<{
   $disabled: string;
   $error: string;
}>`
   outline: none;
   border: ${({ $error }) =>
      $error === 'true'
         ? `1px solid ${colors.DANGER}`
         : `1px solid ${colors.GRAY12}`};
   box-shadow: 0 0 0 1px
      ${({ $error }) => ($error === 'true' ? colors.DANGER : colors.PRIMARY)};
   border-radius: 4px;
   padding: 8px 12px;
   font-size: 14px;
   color: ${({ $disabled }) =>
      $disabled === 'true' ? colors.GRAY5 : colors.GRAY1};
   background: ${({ $disabled }) =>
      $disabled === 'true' ? colors.GRAY13 : colors.WHITE};
   cursor: ${({ $disabled }) =>
      $disabled === 'true' ? 'not-allowed' : 'text'};

   &:focus {
      border-color: ${({ $error }) =>
         $error === 'true' ? colors.DANGER : colors.PRIMARY};
      box-shadow: 0 0 0 1px
         ${({ $error }) => ($error === 'true' ? colors.DANGER : colors.PRIMARY)};
   }

   &::placeholder {
      color: ${colors.GRAY5};
   }
`;

const ErrorWrapper = styled.div`
   display: flex;
   justify-content: flex-start;
   align-items: center;
   gap: 5px;
`;

const LabelRequired = styled.p`
   /* padding-top: 5px; */
   color: ${colors.DANGER};
   font-size: 14px;
`;

export default InputTextarea;
